import { CoreApplicationContext } from '@eventbrite/context-gen';
import React from 'react';
import { BrowserRouter, Route, StaticRouter, Switch } from 'react-router-dom';
import {
    PointOfInterestPage,
    ThingsToDoBasePage,
    ThingsToDoPage,
} from './pages';
import { AppProps } from './types';

export const Routes: React.FC<AppProps & CoreApplicationContext> = (props) => {
    const Router = (
        process.env.REACT_APP_TARGET === 'server' ? StaticRouter : BrowserRouter
    ) as React.ElementType;

    return (
        <Router
            location={props.request.path}
            context={{}}
            forceRefresh={props.isBotRequest}
        >
            <Switch>
                <Route
                    path="/ttd/:locationSlug/"
                    exact={true}
                    render={() => (
                        <ThingsToDoBasePage footerLinks={props.footerLinks}>
                            <ThingsToDoPage
                                breadcrumbs={props.breadcrumbs}
                                trendingSearchesResult={
                                    props.trendingSearchesResult
                                }
                                nearbyCitiesResult={props.nearbyCitiesResult}
                                categories={props.categories}
                                topEventsData={props.topEventsData}
                                heroSection={props.heroSection}
                                topOrganizers={props.topOrganizers}
                                editorialCollections={
                                    props.editorial_collections
                                }
                            />
                        </ThingsToDoBasePage>
                    )}
                />
                <Route
                    path="/poi/:pointOfInterest/"
                    exact={true}
                    render={() => (
                        <ThingsToDoBasePage footerLinks={props.footerLinks}>
                            <PointOfInterestPage
                                shortPlaceName={props.shortPlaceName}
                            />
                        </ThingsToDoBasePage>
                    )}
                />
            </Switch>
        </Router>
    );
};
